import { FunctionalComponent, createContext, h } from 'preact';
import { useCallback, useContext, useState } from 'preact/hooks';
import { Settings } from '@usercentrics/cmp-browser-sdk';

type SettingsContextType = {
  loading: boolean;
  settings: Settings;
  setSettings: (settings: Settings) => void;
};

const initialValue = {
  loading: true,
  /* eslint-disable-next-line */
  settings: {} as Settings,
  /* eslint-disable-next-line */
  setSettings: () => {},
};

const SettingsContext = createContext<SettingsContextType>(initialValue);

export const SettingsContextProvider: FunctionalComponent = ({ children }) => {
  const [loading, setLoading] = useState(initialValue.loading);
  const [settings, setSettings] = useState(initialValue.settings);

  const setSettingsHandler = useCallback((givenSettings: Settings): void => {
    setSettings(givenSettings);
    setLoading(false);
  }, []);

  return (
    <SettingsContext.Provider value={{ loading, setSettings: setSettingsHandler, settings }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettingsContext = (): SettingsContextType => {
  return useContext(SettingsContext);
};
